import { transparentize } from 'polished'
import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'

export const NextUpEndMain = styled.div`
  position: relative;
`

export const NextUpEndBackground = styled.div`
  position: absolute;
  inset: 0;

  ::before {
    content: '';
    position: absolute;
    inset: 0;
    display: block;
    z-index: 1;
    background-color: ${transparentize(0.5, '#000000')};
  }

  img {
    height: 100%;
    width: 100%;
  }
`

export const NextUpEndContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  color: ${colors.light};
`
